import React, { useState } from "react";

import { ErrorUtils } from '../../utils/errorUtils';

import { StyledForm } from "../../styled-components/StyledForm.style";
import { StyledTablePage } from "../../styled-components/StyledTablePage.style";

import Modal from 'react-modal';
import Flex from '@react-css/flex';
import api from '../../services/api';

export const ModalReverterTS = ({
    isOpen,
    loadPage,
    idTimesheet,
    onAfterOpen,
    onRequestClose,
}) => {
    var [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const onClickHandler = async () => {
        setLoading(true)
        setErrorMessage('')

        try {
            await api.patch(`Timesheet/${idTimesheet}/revert`);
            await loadPage();
            setLoading(false);
            onRequestClose(false);
        } catch (err) {
            const msg = ErrorUtils.getErrorMessage(err);

            setErrorMessage(msg);
            setLoading(false);
        }
    }

    const style = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: "0px",
            minWidth: '30%',
            overflowY: 'auto',
            minHeight: '20%',
            maxHeight: '90%',
        },
        overlay: {
            zIndex: 9999
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            onAfterOpen={onAfterOpen}
            onRequestClose={onRequestClose}
            contentLabel="Reverter Timesheet"
            style={style}
            ariaHideApp={false}
            shouldCloseOnOverlayClick={false}
        >
            <StyledForm>
                <p className="modal-close" onClick={onRequestClose}>X</p>
            </StyledForm>
            <StyledForm>
                <StyledTablePage>
                    <Flex>
                        <Flex.Item className="modal-width">
                            <div className="position-relative form-group">
                                <p className="modal-title">Reverter Timesheet</p>
                            </div>
                        </Flex.Item>
                    </Flex>
                    <Flex.Item style={{ marginTop: '7px', marginBottom: '21px' }}>
                        Deseja realmente reverter o timesheet para em andamento?
                        {errorMessage && (
                            <div style={{ color: 'red', marginTop: '10px' }}>
                                {errorMessage}
                            </div>
                        )}
                    </Flex.Item>
                    <Flex style={{ textAlign: "right" }}>
                        <Flex.Item style={{ width: '100%' }}>
                            {
                                loading ?
                                    <div className="spinner-border ms-auto" style={{ color: "#EE4B21" }} role="status" aria-hidden="true"></div>
                                    : <input className='default-button-red' value='Reverter' type="button" onClick={onClickHandler} />
                            }
                        </Flex.Item>
                    </Flex>
                </StyledTablePage>
            </StyledForm>
        </Modal>
    );
};
